import React, { createContext, useContext, useState } from "react";

type SnackbarSeverity = "success" | "error";

export interface SnackbarContextType {
  open: boolean;
  message: string;
  severity: SnackbarSeverity;
  showSnackbar: (msg: string) => void;
  showError: (msg: string) => void;
  hideSnackbar: () => void;
}

const SnackbarContext = createContext<SnackbarContextType>({
  open: false,
  message: "",
  severity: "success",
  showSnackbar: () => {},
  showError: () => {},
  hideSnackbar: () => {},
});

export const SnackbarProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState<SnackbarSeverity>("success");

  function showSuccess(msg: string) {
    setMessage(msg);
    setSeverity("success");
    setOpen(true);
  }

  function showError(msg: string) {
    setMessage(msg);
    setSeverity("error");
    setOpen(true);
  }

  function hideSnackbar() {
    setOpen(false);
  }

  const value: SnackbarContextType = {
    open,
    message,
    severity,
    showSnackbar: showSuccess,
    showError,
    hideSnackbar,
  };

  return (
    <SnackbarContext.Provider value={value}>
      {children}
    </SnackbarContext.Provider>
  );
};

export function useSnackbar() {
  return useContext(SnackbarContext);
}
